import React, { Component } from 'react';
import { addCommas } from '../modules/helpers';
import '../css/material-usage-chart.css';
import LoadingAnimation from "./loading-animation";

export default class MaterialUsageChart extends Component {
  render() {
    const { materialUsageByResinName } = this.props;
    if (!materialUsageByResinName) {
      return <span/>
    }
    if (this.props.loading) {
      return <LoadingAnimation/>
    }

    const maxResinUsage = this.findMaxResinUsage(materialUsageByResinName);
    const listOfResinName = Object.keys(materialUsageByResinName);
    listOfResinName.sort((name1, name2) => materialUsageByResinName[name2] - materialUsageByResinName[name1]);
    const listOfMaterialUsageBars = [];
    listOfResinName.forEach((resinName, index) => {
      const resinUsage = materialUsageByResinName[resinName];
      const opacity = 1 - 0.2 * index;
      listOfMaterialUsageBars.push(
        <MaterialUsageBar
        key={index}
        resinName={resinName}
        resinUsage={resinUsage}
        scale={listOfResinName.length === 1 ? 0.5 : resinUsage / maxResinUsage}
        opacity={opacity > 0 ? opacity : 0.05}
      />
      )
    })
    listOfMaterialUsageBars.sort((usageBar1, usageBar2) => usageBar2.props.resinUsage - usageBar1.props.resinUsage);

    return <div className='chart-container'>
      { listOfMaterialUsageBars }
    </div>
  }

  findMaxResinUsage(materialUsageByResinName) {
    let maxResinUsage = 0;
    Object.keys(materialUsageByResinName).forEach(resinName => {
      const resinUsage = materialUsageByResinName[resinName];
      maxResinUsage = Math.max(maxResinUsage, resinUsage);
    })
    return maxResinUsage;
  }
}

class MaterialUsageBar extends Component {
  render() {
    const { resinName, resinUsage, scale, opacity } = this.props;
    return <div className='material-usage-bar-container'>
      <div className='resinNameChart'><i className='material-icons'>invert_colors</i>{resinName}</div>
      <div style={{ width: `${scale * 100}%`, opacity: opacity }} className='material-usage-bar'>
        <span>{addCommas(resinUsage)} mL</span>
      </div>
    </div>
  }
}


// WEBPACK FOOTER //
// ./src/components/material-usage-chart.js